<template>
  <div v-show="show" class="alert alert-dismissible fade show" v-bind:class="alertClass" role="alert">
    <button v-on:click="closeAlert" type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <strong v-show="title">{{title}}</strong>{{content}}
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'alert',
  props: {
    type: {
      type: String,
      required: true,
      default: 'primary'
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    content: {
      type: String,
      required: false,
      default: ''
    },
    show: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    alertClass () {
      return 'alert-' + this.type
    }
  },
  methods: {
    closeAlert () {
      this.$emit('close-alert')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Alert.vue